module.exports = __webpack_public_path__ + "img/heart-fill.207737aa.svg";